import { useTranslation } from 'react-i18next';
import { trackAppDownload } from 'lib/Tracking';
import Heading from 'components/Home/Heading';
// assets
import { screen, colors } from 'components/styles/variables';
import oneAndDone from 'public/static/images/home/why_autolist/one-and-done.jpg';
import beInTheKnowEn from 'public/static/images/home/why_autolist/be-in-the-know.png';
import beInTheKnowEs from 'public/static/images/home/why_autolist/be-in-the-know-es.png';
import searchOnTheGoEn from 'public/static/images/home/why_autolist/search-on-the-go.jpg';
import searchOnTheGoEs from 'public/static/images/home/why_autolist/search-on-the-go-es.jpg';

const WhyAutolist = () => {
  const { t, i18n } = useTranslation();
  let beInTheKnow = beInTheKnowEn;
  let searchOnTheGo = searchOnTheGoEn;

  if (i18n.language === 'es') {
    beInTheKnow = beInTheKnowEs;
    searchOnTheGo = searchOnTheGoEs;
  }

  return (
    <div className="why-autolist">
      <div className="container">
        <Heading title={t('home.why.title')} />
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div className="tile">
              <div className="content">
                <img src={oneAndDone} alt={t('home.why.leftTitle')} />
                <div className="title" role="heading">
                  {t('home.why.leftTitle')}
                </div>
                <div className="subtext">{t('home.why.leftText')}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div className="tile">
              <div className="content">
                <img
                  loading="lazy"
                  src={beInTheKnow}
                  alt={t('home.why.centerTitle')}
                />
                <div className="title" role="heading">
                  {t('home.why.centerTitle')}
                </div>
                <div className="subtext">{t('home.why.centerText')}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div className="tile">
              <div className="content">
                <img
                  loading="lazy"
                  src={searchOnTheGo}
                  alt={t('home.why.rightTitle')}
                />
                <div className="title" role="heading">
                  {t('home.why.rightTitle')}
                </div>
                <div className="subtext app-links">
                  {t('home.why.rightText')}
                  &nbsp;
                  <a
                    href="https://play.google.com/store/apps/details?id=com.autolist.autolist&referrer=utm_source%3Dhomepage%26utm_medium%3Dbody-link%26utm_campaign%3Dapp%20install%20body%20link"
                    onClick={() => {
                      trackAppDownload({
                        category: 'home_page',
                        label: 'search_on_the_go',
                        type: 'android',
                      });
                    }}
                    target="_blank"
                    aria-label={t('accessibility.newWindow')}
                  >
                    {t('home.why.androidApp')}
                  </a>
                  &nbsp;
                  {t('home.why.or')}
                  &nbsp;
                  <a
                    href="https://itunes.apple.com/us/app/id1058636900?utm_source=homepage&amp;utm_medium=body-link&amp;utm_campaign=app%20install%20body%20link"
                    onClick={() => {
                      trackAppDownload({
                        category: 'home_page',
                        label: 'search_on_the_go',
                        type: 'ios',
                      });
                    }}
                    target="_blank"
                    aria-label={t('accessibility.newWindow')}
                  >
                    {t('home.why.iosApp')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .why-autolist {
          font-weight: 100;
          color: ${colors.G4};
        }

        h2 {
          font-size: 30px;
          text-transform: uppercase;
          font-weight: 100;
          margin: 30px 0 15px 0;
          color: ${colors.G4};
        }

        img {
          width: 100%;
        }

        .tile {
          padding: 1px;
          position: relative;
        }

        .title {
          font-size: 25px;
          font-weight: 600;
          line-height: 40px;
          margin-top: 15px;
        }

        .subtext {
          font-size: 18px;
          line-height: 24px;
          margin: 2px 0 30px 0;
          padding-right: 40px;
        }

        @media (min-width: ${screen.smMin}) {
          .subtext {
            margin-top: 6px;
          }
        }

        .content:hover {
          cursor: default;
        }

        a,
        a:hover {
          font-size: 18px;
          text-decoration: none;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default WhyAutolist;
